<template>
  <div
    :class="[
      'navigation-menu-dropdown',
      cssClass,
      activeState === 'active' ? 'active' : '',
      !isOpen || !dropDownAbove ? 'bottom-radius' : ''
    ]"
  >
    <div
      :aria-expanded="isOpen"
      class="navigation-menu-dropdown__header"
      role="button"
      tabindex="0"
      @click="toggleDropdown"
      @keydown.enter="toggleDropdown"
      @keydown.space="(event) => toggleDropdown(event, true)"
    >
      <img v-if="iconPath !== ''" :src="getImageUrl(iconPath)" class="icon" alt="Icon" />
      <h4 :class="['navigation-menu-dropdown__heading', cssClass]" :style="{ fontSize: fontSize }">
        {{ title }}
      </h4>
      <img :src="imageSourceArrow" :class="[arrowDirectionClass]" alt="Dropdown arrow" />
    </div>
    <div
      v-show="isOpen"
      class="navigation-menu-dropdown__content"
      :class="{ 'navigation-menu-dropdown__above': dropDownAbove }"
      @click="toggleDropdown"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDropdown',
  props: {
    title: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      validator: (prop) => ['dark', 'light', 'color'].includes(prop),
      default: 'dark'
    },
    activeState: {
      type: String,
      validator: (prop) => ['active', 'inactive'].includes(prop),
      required: false,
      default: 'inactive'
    },
    iconPath: {
      type: String,
      default: ''
    },
    dropDownAbove: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      arrowImageSource: '',
      isOpen: false
    }
  },
  computed: {
    imageSourceArrow() {
      return ['dark', 'color'].includes(this.cssClass)
        ? this.getImageUrl('drop-down-arrow')
        : this.getImageUrl('drop-down-arrow-dark')
    },
    arrowDirectionClass() {
      return this.isOpen ? 'arrow--up' : 'arrow--down'
    }
  },
  methods: {
    closeDropdown() {
      if (this.isOpen) this.isOpen = !this.isOpen
    },
    toggleDropdown(event, preventDefault) {
      if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
      this.isOpen = !this.isOpen
    },
    getImageUrl(path) {
      return new URL(`../../../assets/${path}.svg`, import.meta.url).href
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/mixins.scss';
@use '@/styles/variables.scss';

.bottom-radius {
  border-bottom-left-radius: variables.$border-radius-medium;
  border-bottom-right-radius: variables.$border-radius-medium;
}

.navigation-menu-dropdown {
  border-top-left-radius: variables.$border-radius-medium;
  border-top-right-radius: variables.$border-radius-medium;
  max-height: 2 * variables.$max-height-navigation-menu-container;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  min-width: 100px;
  z-index: 2;
  position: relative;
  &.color {
    background-color: variables.$color-primary;
    &.active {
      background-color: variables.$color-grey-blue-darker;
    }
  }
  &.light {
    background-color: variables.$color-grey-light;
    &.active {
      background-color: variables.$color-grey;
    }
  }
  &.dark {
    background-color: variables.$color-grey-blue-dark;
    &.active {
      background-color: variables.$color-grey-blue-darker;
    }
  }

  &__header {
    align-items: center;
    display: flex;
    height: variables.$height-dropdown-filter-menu;
    justify-content: space-between;
  }
  &__heading {
    font-size: 20px;
    margin-left: variables.$margin-drop-down-filter;
    padding-right: variables.$margin-small;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &.color {
      color: variables.$color-text-white-70;
    }
    &.light {
      color: variables.$color-grey-darker;
    }
    &.dark {
      color: variables.$color-text-white-70;
    }
  }
  &__content {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 300px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
    border-bottom-left-radius: variables.$border-radius-medium;
    border-bottom-right-radius: variables.$border-radius-medium;
    @include mixins.scrollbar-vertical;
  }
  &__above {
    position: absolute;
    width: 100%;
    top: variables.$height-dropdown-filter-menu;
  }
}
.arrow {
  border: solid variables.$color-white-70;
  border-width: 0 3px 3px 0;
  display: inline-block;
  margin-right: variables.$margin-drop-down-filter;
  padding: 5px;
  width: 10px;
  &--down {
    padding-left: 0;
    padding-right: 14px;
  }
  &--up {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    padding-left: 14px;
    padding-right: 0;
  }
}

.icon {
  display: inline-block;
  margin: auto 20px auto 20px;
}
</style>
